module.exports = __webpack_public_path__ + "static/media/realtimetext-semibold.c0824670.woff2";